import { Flex, Text, TextVariant } from '@mprolab/uikit'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ComingSoonPlaceholder: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Flex flexDirection="column" gap="8px">
      <Text textAlign="center" variant={TextVariant.H4}>
        {t('comingSoon')}
      </Text>
    </Flex>
  )
}

export default ComingSoonPlaceholder
